import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { LinkIcon } from '@heroicons/react/24/outline';

// Simple cache to avoid repeated lookups during the same session
const bugIdCache = new Map();

const SmartBugLink = ({ mongoId, originalUrl }) => {
    const [displayId, setDisplayId] = useState(bugIdCache.get(mongoId) || null);
    const [loading, setLoading] = useState(!displayId);

    useEffect(() => {
        if (displayId) return;

        const fetchBugDetails = async () => {
            try {
                // Fetch just the bug details
                const { data } = await axios.get(`/api/bugs/${mongoId}`);
                const bugCode = data.data.bugId;

                if (bugCode) {
                    bugIdCache.set(mongoId, bugCode);
                    setDisplayId(bugCode);
                }
            } catch (err) {
                console.error('Error fetching smart link details:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchBugDetails();
    }, [mongoId, displayId]);

    // If it's a valid internal bug, show the clean BUG-XXX label
    if (displayId) {
        return (
            <Link
                to={`/bugs/${displayId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-[#0052CC] hover:underline bg-[#E9F2FF] px-1 rounded mx-0.5 transition-colors inline-flex items-center gap-1"
                title={`View Bug ${displayId}`}
            >
                <LinkIcon className="h-3.5 w-3.5 opacity-70" /> {displayId}
            </Link>
        );
    }

    // While loading, show a "resolving" state
    if (loading) {
        return (
            <span className="animate-pulse text-[#0052CC] bg-gray-100 px-1 rounded text-xs">
                resolving link...
            </span>
        );
    }

    // Fallback to original URL if not found or error
    return (
        <a
            href={originalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0052CC] hover:underline break-all"
        >
            {originalUrl}
        </a>
    );
};

export default SmartBugLink;
